export enum CompanySubTypeEnum {
  PORT = 'PORT',
  AIRPORT = 'AIRPORT',
  GHA = 'GHA',
  SHIPPER = 'SHIPPER',
  TRUCKING = 'TRUCKING',
  OTHER = 'OTHER',
}
